import Site from 'stores/Site'
import Component from 'classes/Component'
import Form from 'components/Form'
import Book from 'components/Book'
import Select from 'components/Select'
import {createFocusTrap} from 'utils/focusTrap'

export default class Drawer extends Component {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.el = Site.body.querySelector('.drawer')
        this.bg = this.el.querySelector('.d-bg')
        this.close = this.el.querySelector('.d-close')
        this.activeItem = 'stay'
        this.nav = {
            stay: this.el.querySelector('.btn[data-id="stay"]'),
            dine: this.el.querySelector('.btn[data-id="dine"]'),
            spaces: this.el.querySelector('.btn[data-id="spaces"]')
        }
        this.items = {
            stay: this.el.querySelector('.d-item[data-id="stay"]'),
            dine: this.el.querySelector('.d-item[data-id="dine"]'),
            spaces: this.el.querySelector('.d-item[data-id="spaces"]')
        }

        Object.entries(this.nav).forEach(([id, el]) => {
            el.addEventListener('click', () => {
                this.setItemActive(id)
            })
        })

        this.bg.addEventListener('click', this.hide.bind(this))
        this.close.addEventListener('click', this.hide.bind(this))

        this.focusTrap = createFocusTrap(this.el)

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && Site.html.classList.contains('drawer-active')) {
                this.hide()
            }
        })

        this.book = new Book({
            el: this.el.querySelector('.book-drawer'),
            isDrawer: true
        })

        const form = this.items.spaces.querySelector('.wpcf7-form')

        if (form) {
            this.form = new Form({el:form})
            this.form.init()
        }
    }

    show(id = null) {
        if (id) {
            this.setItemActive(id)
        }

        this._triggerEl = document.activeElement

        Site.scroll.stop()
        Site.html.classList.add('drawer-active')
        this.el.removeAttribute('aria-hidden')
        this.el.removeAttribute('inert')

        const wrapper = this.el.querySelector('.d-wrapper')
        if (wrapper) wrapper.focus()

        this.focusTrap.activate()
    }

    hide() {
        Site.scroll.start()
        Site.html.classList.remove('drawer-active')
        this.el.setAttribute('aria-hidden', 'true')
        this.el.setAttribute('inert', '')

        this.focusTrap.deactivate()

        if (this._triggerEl) {
            this._triggerEl.focus()
            this._triggerEl = null
        }
    }

    setItemActive(id) {
        this.nav[this.activeItem].classList.remove('active')
        this.items[this.activeItem].classList.remove('active')

        console.log(id)

        this.activeItem = id
        this.nav[id].classList.add('active')
        this.items[id].classList.add('active')
    }

    pageLoaded() {
        super.pageLoaded()
    }

    update() {
        super.update()
    }

    resize() {
        super.resize()
    }

    destroy() {
        super.destroy()
    }
}